import { Layout } from '@sbercloud/uikit-product-site-layout';
import { CSS_BREAKPOINTS } from '@sbercloud/uikit-product-utils';
import { PropsWithChildren } from 'react';

import { useServerDataCtx } from '@/hooks/ctx';
import { useLayoutType } from '@/hooks/useLayoutType';

type LayoutSectionWrapperProps = PropsWithChildren<{ className?: string }>;

export function LayoutSectionWrapper({ children, className }: LayoutSectionWrapperProps) {
  const { headers } = useServerDataCtx();
  const layoutType = useLayoutType(CSS_BREAKPOINTS, headers.xLayoutType);
  return (
    <Layout.SectionWrapper className={className} layoutType={layoutType}>
      {children}
    </Layout.SectionWrapper>
  );
}
